import { Component, OnInit } from '@angular/core';
import { LoginSignupService } from 'src/app/shared/services/node-api/login-signup.service';

@Component({
  selector: 'app-empty-cart-layout',
  templateUrl: './empty-cart-layout.component.html',
  styleUrls: ['./empty-cart-layout.component.scss'],
})
export class EmptyCartLayoutComponent implements OnInit {
  plan: string;
  constructor(private loginSignupService: LoginSignupService,) {}

  ngOnInit(): void {
    this.plan = this.loginSignupService.getUserSession().user.plan;
  }

  isPremium(): boolean {
    return this.plan === 'plan_premium';
  }
}
